export enum VariationStockStatutExportEnum {
  NON_EXPORTE = 'NON_EXPORTE',
  A_EXPORTER = 'A_EXPORTER',
  EXPORTE = 'EXPORTE'
}
